/** @format */

import { CertonaService, RecommendationDataService } from '@product-recommendations/data-access';
import {
	Component,
	ComponentRef,
	DestroyRef,
	inject,
	input,
	OnInit,
	TemplateRef,
	viewChild
} from '@angular/core';
import {
	HmfActionTextComponent,
	HmfDrawerComponent,
	HmfModalFactoryService,
	HmfProductCardComponent,
	HmfProductData
} from '@dsg-tech/homefield-angular';

import { CommonModule } from '@angular/common';
import { WINDOW } from '@shared/data-access/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'product-recommendations-components-product-recommendations-rail',
	standalone: true,
	imports: [CommonModule, HmfProductCardComponent, HmfActionTextComponent],
	templateUrl: './product-recommendations-rail.component.html',
	styleUrl: './product-recommendations-rail.component.scss'
})
export class ProductRecommendationsRailComponent implements OnInit {
	private window = inject<Window>(WINDOW);
	private certonaService = inject(CertonaService);
	private readonly destroyRef = inject(DestroyRef);
	private recommendationDataService = inject(RecommendationDataService);
	private modalFactoryService = inject(HmfModalFactoryService);

	schemeName = input<string>('product2_rr');
	title = input<string>('Customers Also Bought');

	certonaRecommendationsState = this.certonaService.certonaRecommendationsState;
	productRecommendationsList: string[] | HmfProductData[] = ['', '', '', ''];

	private recDrawerRef: ComponentRef<HmfDrawerComponent>;
	recDrawerContent = viewChild.required<TemplateRef<unknown>>('recDrawerContent');

	ngOnInit(): void {
		this.certonaRecommendationsState
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((state) => {
				if (
					state.certonaRecommendations.source === 'Certona' ||
					state.certonaRecommendations.source === 'Monetate'
				) {
					const scheme = state.certonaRecommendations.resonance.schemes.find(
						(data) => data.scheme === this.schemeName()
					);
					if (scheme?.items) {
						this.productRecommendationsList = scheme.items.map((product) =>
							this.recommendationDataService.mapSchemaItemToProductCardData(product)
						);
					}
				}
			});
	}

	openDrawer() {
		if (!this.recDrawerRef) {
			this.recDrawerRef = this.modalFactoryService.create(
				HmfDrawerComponent,
				{
					headerText: this.title(),
					closable: true,
					mobilePeek: true,
					direction: 'right',
					isCloseButtonSticky: true,
					size: 'small'
				},
				this.recDrawerContent()
			);
		}

		this.recDrawerRef.instance.openDrawer();
	}

	/**
	 * @description Event handler for when a homefield card is clicked
	 * @param item - The HmfProductData that was clicked
	 */
	handleProductCardClicked(item: HmfProductData): void {
		if (!item) return;

		this.window.open(item.assetSeoUrl, '_blank').focus();
	}
}
